var map = {
	"./A_I.svg": "d64d",
	"./Add to.svg": "6f68",
	"./Application information.svg": "bc41",
	"./Check information.svg": "d721",
	"./Essential information.svg": "951c",
	"./add-circle.svg": "876a",
	"./add.svg": "c2a3",
	"./addVideo.svg": "d399",
	"./ai.svg": "ad4c",
	"./anwser.svg": "b29a",
	"./applyInfor.svg": "fcba",
	"./audit.svg": "d393",
	"./basicInfor.svg": "baed",
	"./check-info.svg": "575d",
	"./checkInfor.svg": "8e5a",
	"./consultation.svg": "edac",
	"./copy 9 (1).svg": "3c9f",
	"./copy 9 (2).svg": "09c7",
	"./date.svg": "235f",
	"./delete.svg": "59a1",
	"./detailInfor.svg": "ed98",
	"./detailed information.svg": "c71a",
	"./diagnostic.svg": "df19",
	"./doctor.svg": "bc4d",
	"./document.svg": "fd28",
	"./edit-history.svg": "e679",
	"./empty.svg": "c091",
	"./example.svg": "30c3",
	"./eye-close.svg": "efcd",
	"./eye.svg": "4df5",
	"./folder-1.svg": "3ab4",
	"./folder-2.svg": "39fa",
	"./form.svg": "eb1b",
	"./from-outside.svg": "31d0",
	"./help.svg": "c932",
	"./history.svg": "c023",
	"./historylist.svg": "c6a9",
	"./home.svg": "6bbe",
	"./hospital.svg": "5f91",
	"./info-circle.svg": "a14d",
	"./lock.svg": "ab00",
	"./menu.svg": "bd3d",
	"./mobile.svg": "30d4",
	"./nested.svg": "dcf8",
	"./news.svg": "c862",
	"./news_hot.svg": "3ac3",
	"./password.svg": "2a3d",
	"./patientDetail-Round.svg": "c47e",
	"./pdf.svg": "f9a1",
	"./people_list.svg": "2380",
	"./preview.svg": "e6c2",
	"./preview_1.svg": "f379",
	"./print.svg": "04d5",
	"./question.svg": "ae00",
	"./reason.svg": "acf2",
	"./record.svg": "b3a3",
	"./registration.svg": "a46c",
	"./relevance.svg": "71ee",
	"./return.svg": "3488",
	"./returnReason.svg": "fbd4",
	"./right.svg": "9a71",
	"./risSubmit.svg": "5585",
	"./save.svg": "0e55",
	"./screening.svg": "0830",
	"./search.svg": "8e8d",
	"./seeImg.svg": "774c",
	"./set-image.svg": "e486",
	"./setting.svg": "05ff",
	"./star.svg": "708a",
	"./start-check.svg": "3534",
	"./statistics.svg": "a1cf",
	"./table.svg": "47f1",
	"./to-outside.svg": "c4c4",
	"./tree.svg": "93cd",
	"./triage.svg": "dbd9",
	"./user-1.svg": "1953e",
	"./user.svg": "b3b5",
	"./userinfo.svg": "f84b",
	"./userlist.svg": "d045",
	"./write.svg": "4fbd",
	"./writereport.svg": "6ef6",
	"./一脉影像.svg": "b4b7",
	"./人.svg": "6b9c",
	"./保存.svg": "34f1",
	"./修改检查信息.svg": "baa3",
	"./关闭 .svg": "c955",
	"./删除.svg": "ce94",
	"./医院.svg": "bc74",
	"./历史记录.svg": "d793",
	"./基本资料.svg": "d274",
	"./影像预览.svg": "5546",
	"./患者登记修改.svg": "752d",
	"./患者详情.svg": "1764",
	"./报告模块.svg": "3ad0",
	"./搜索.svg": "5738",
	"./文件信息.svg": "4f17",
	"./文件夹打开.svg": "3d3d",
	"./文件夹闭合.svg": "b2e3",
	"./文档.svg": "a22c",
	"./新增.svg": "c9f9",
	"./日期.svg": "6e9f",
	"./检查模块.svg": "60ca",
	"./添加.svg": "ef9e",
	"./申请信息.svg": "8996",
	"./申请单.svg": "e3f5",
	"./登记总数.svg": "f799",
	"./立项申请.svg": "74bd",
	"./答题记录.svg": "150b",
	"./统计报表.svg": "2a94",
	"./详细信息.svg": "1af2",
	"./辅助_AI.svg": "141a",
	"./返回.svg": "60fa",
	"./问题反馈.svg": "bb18",
	"./预览.svg": "9e99"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";